import React from 'react';
import { motion } from 'framer-motion';
import './TechStack.css';

const TechStack = () => {
  const technologies = [
    { name: "React / Next.js", category: "Frontend" },
    { name: "Node.js / NestJS", category: "Backend" },
    { name: "Python / FastAPI", category: "Backend" },
    { name: "Laravel / PHP", category: "Backend" },
    { name: "AWS / Azure", category: "Cloud" },
    { name: "Docker / K8s", category: "DevOps" },
    { name: "Flutter / React Native", category: "Mobile" },
    { name: "TensorFlow / AI", category: "AI/ML" },
    { name: "MongoDB / PostgreSQL", category: "Database" },
    { name: "GraphQL / REST", category: "API" }
  ];

  return (
    <section id="tech" className="tech-stack-section">
      <div className="container">
        <h2 className="section-title">Our <span className="gradient-text">Tech Stack</span></h2>
        <p className="section-subtitle">
          We focus on emerging technologies for building high-performing web & mobile products 
          that can be securely deployed in the cloud.
        </p>
        
        <motion.div 
          className="tech-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.name}
              className="tech-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="tech-name">{tech.name}</div>
              <div className="tech-category">{tech.category}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechStack;